import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./RemoteCredit.css";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import * as links from "../../../utils/links";
import { Button, Input, Table } from "antd";
import moment from "moment";

const RemoteCredit = () => {
  const { id } = useParams();
  const location = useLocation();
  const maquinaInfos = location.state;

  const {
    setDataUser,
    authInfo,
    setNotiMessage
  } = useContext(AuthContext);

  const { dataUser } = authInfo;
  const navigate = useNavigate();
  const token = authInfo?.dataUser?.token;

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({ valor: "" });
  const [errors, setErrors] = useState({});
  const [loadingTable, setLoadingTable] = useState(false);
  const [listHistory, setListHistory] = useState([]);
  const [searchText, setSearchText] = useState("");

  const nomeMaquina = maquinaInfos?.nome || "Máquina";

  useEffect(() => {
    if (id) getData(id);
  }, [id]);

  const handleChange = (name, value) => {
    setData(prev => ({
      ...prev,
      [name]: value
    }));

    setErrors(prev => {
      let temp = { ...prev };
      delete temp[name];
      return temp;
    });
  };

  const onSave = () => {
    let errorsTemp = {};

    if (!data.valor || data.valor.trim() === "") {
      errorsTemp.valor = "Este campo é obrigatório";
    }

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);

    axios.post(
      `${process.env.REACT_APP_SERVIDOR}/credito-remoto-cliente`,
      {
        id: id,
        valor: data.valor,
      },
      {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      }
    )
    .then(res => {
      setIsLoading(false);
      setData({ valor: "" });

      setNotiMessage({
        type: "success",
        message: res?.data?.retorno || "Enviado com sucesso"
      });

      getData(id);
    })
    .catch(err => {
      setIsLoading(false);

      if ([401, 403].includes(err?.response?.status)) {
        setNotiMessage({
          type: "error",
          message: "Sessão expirada"
        });

        if (dataUser?.key === "ADMIN") {
          navigate(links.ADMIN_SIGNIN);
        } else {
          navigate(links.SIGNIN);
        }

        setDataUser(null);
      } else {
        setNotiMessage({
          type: "error",
          message: `Erro: ${err.response?.data?.msg || ""}`
        });
      }
    });
  };

  const getData = (id) => {
    setLoadingTable(true);

    axios.get(
      `${process.env.REACT_APP_SERVIDOR}/creditos-remotos-client?idMaquina=${id}`,
      {
        headers: {
          "x-access-token": token,
        },
      }
    )
    .then(res => {
      setLoadingTable(false);

      if (Array.isArray(res.data)) {
        setListHistory(res.data);
      }
    })
    .catch(err => {
      setLoadingTable(false);

      if ([401, 403].includes(err?.response?.status)) {
        setNotiMessage({
          type: "error",
          message: "Sessão expirada"
        });

        if (dataUser?.key === "ADMIN") {
          navigate(links.ADMIN_SIGNIN);
        } else {
          navigate(links.SIGNIN);
        }

        setDataUser(null);
      }
    });
  };

  const columns = [
    {
      title: "Valor",
      dataIndex: "valor",
      render: (v) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(v),
    },
    {
      title: "Data Hora",
      dataIndex: "dataHora",
      render: (d) => moment(d).format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      title: "E-mail",
      dataIndex: "email",
    },
    {
      title: "IP",
      dataIndex: "ip",
    },
    {
      title: "Id Máquina",
      dataIndex: "idMaquina",
    },
  ];

  return (
    <>
      {isLoading && <LoadingAction />}

      <div className="AddMachine_container">
        <div className="AddMachine_header">

          {/* 🔥 CORRIGIDO */}
          <div className="AddMachine_header_title">
            Adicionando crédito em {nomeMaquina}
          </div>

          <div
            className="AddMachine_header_back"
            onClick={() => {
              navigate(`${links.FORNECEDOR_SEARCH_CANAIS}/${id}`, {
                state: maquinaInfos,
              });
            }}
          >
            VOLTAR
          </div>
        </div>

        <div className="AddMachine_content">
          <div className="AddMachine_itemField">
            <label>Valor:</label>

            <Input
              value={data.valor}
              type="number"
              onChange={(e) =>
                handleChange("valor", e.target.value)
              }
              className={errors.valor ? "AddMachine_inputError" : ""}
            />

            {errors.valor && (
              <div className="AddMachine_itemFieldError">
                {errors.valor}
              </div>
            )}
          </div>

          <Button
            className="AddMachine_saveBtn"
            onClick={onSave}
            disabled={isLoading}
          >
            ENVIAR
          </Button>
        </div>

        <div style={{ padding: 20 }}>
          <h2 style={{ textAlign: "center" }}>
            Histórico
          </h2>

          <Table
            columns={columns}
            dataSource={listHistory}
            loading={loadingTable}
            pagination={false}
          />
        </div>
      </div>
    </>
  );
};

export default RemoteCredit;